import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useManageInterface } from '../hooks/useManageInterface'
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { ManageConfiguration } from '../components/manageconfiguration/ManageConfiguration';
import { ManageFlowProcess } from '../components/manageFlowProcess/ManageFlowProcess';
import { MultiLanguageEditor } from '../../../components/others/MultiLanguageEditor';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { PreviewRenderer } from '../components/preview/PreviewRenderer';
import { Preview } from '../components/preview/Preview';
import InterfaceForm from '../components/InterfaceForm';
import { buildInterfacePayload } from '../helpers/helpers';
import { safeParseJSON } from '../../../utils/jsonValidator';

export const LayoutInterface = () => {
    const [openFullscreenPreview, setOpenFullscreenPreview] = useState(false);
    const navigate = useNavigate();
    const {
        values,
        errorInputs,
        workFlowLists,
        isEdit,
        handleInputChange,
        handleDirectInputChange,
        validateForm,
        save,
        t,
        isSaving
    } = useManageInterface();
    const handleToggleFullscreenPreview = () => setOpenFullscreenPreview(!openFullscreenPreview);
    const parsedFlowProcess = safeParseJSON(values.flow_process);
    const flowProcessEditorValue = useMemo(() => ({
        flow_process: Array.isArray(parsedFlowProcess)
            ? parsedFlowProcess
            : Array.isArray(parsedFlowProcess?.flow_process)
                ? parsedFlowProcess.flow_process
                : Object.keys(parsedFlowProcess || {}).length > 0
                    ? [parsedFlowProcess]
                    : []
    }), [parsedFlowProcess]);

    const handleSave = () => {
        const valid = validateForm();
        if (valid) {
            const payload = buildInterfacePayload(values);
            save(payload);
            handleCancel();
        }
    };
    const handleCancel = () => navigate(-1);

    return (
        <Box sx={{ mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <InterfaceForm
                        values={values}
                        errorInputs={errorInputs}
                        workFlowLists={workFlowLists}
                        isEdit={isEdit}
                        handleInputChange={handleInputChange}
                        t={t}
                    />
                    {/* <<Grid container spacing={2}>
                        Grid size={{ xs: 12, md: 6 }}>
                            <ManageConfiguration
                                data={safeParseJSON(values.configuration)}
                                typeAction={values.type_action}
                                isDisabled={!values?.type_action}
                                isEdit={isEdit}
                                addedConfiguration={handleDirectInputChange}
                                t={t}
                            />
                            <MultiLanguageEditor
                                value={values.configuration}
                                onChange={(e) => handleDirectInputChange("configuration", JSON.stringify(e))}
                                errorInputs={{}}
                                field={{
                                    id: "configuration",
                                    label: "Configuration:"
                                }}
                                htCtrl={"200"}
                                togglePreview={handleToggleFullscreenPreview}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ManageFlowProcess
                                data={safeParseJSON(values.flow_process)}
                                typeAction={values.type_action}
                                isDisabled={!values?.type_action}
                                isEdit={isEdit}
                                addedFlowProcess={handleDirectInputChange}
                                t={t}
                            />

                            <MultiLanguageEditor
                                value={flowProcessEditorValue}
                                onChange={(val) => handleDirectInputChange("flow_process", val?.flow_process || [])}
                                errorInputs={{}}
                                field={{
                                    id: "flow_process",
                                    label: "Flow Process:"
                                }}
                                htCtrl={"200"}
                            />
                        </Grid> 
                    </Grid>
                    */}
                    <PreviewRenderer json={values} onChange={handleDirectInputChange} t={t} isEdit={isEdit} />

                    <Box sx={{ textAlign: 'right', mt: 4 }}>
                        <ActionButtons onSubmit={handleSave} onCancel={handleCancel} disabledSubmit={isSaving} />
                    </Box>
                </CardContent>
            </Card>
            <Preview
                open={openFullscreenPreview}
                onClose={handleToggleFullscreenPreview}
                values={values}
                title="Preview"
            />
        </Box>
    );
};
